export const TOKENS_BOUGHT = 100;

export const getEstimateDailyReward = (totalFarmPosition: number, dailyRewards: number): number =>
  (TOKENS_BOUGHT / (totalFarmPosition + TOKENS_BOUGHT)) * dailyRewards;
